import { createVNode, render } from 'vue';
import type { DirectiveBinding, VNode, Component } from 'vue';

// Define the type for the binding value
interface InjectAfterBindingValue {
  targetSelector: string;
  component: Component;
  props?: Record<string, any>;
  onInjected?: () => void;
}

export default {
  mounted(
    el: HTMLElement,
    binding: DirectiveBinding<InjectAfterBindingValue>,
    vnode: VNode,
  ) {
    const { targetSelector, component, props, onInjected } = binding.value;

    const targetElement = el.querySelector(targetSelector);

    if (targetElement) {
      const instance = createVNode(component, props);

      const container = document.createElement('div');

      render(instance, container);

      targetElement.insertAdjacentElement('afterend', container);

      if (typeof onInjected === 'function') {
        onInjected();
      }
    }
  },
};
